import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Suppress unhandled API errors from showing the dev overlay
window.addEventListener('unhandledrejection', e => { e.preventDefault(); });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
